export const ICON_NAMES = [
  'dashboard',
  'calendar',
  'users',
  'reports',
  'invoice',
  'settings',
  'help',
  'menu',
  'search',
  'bell',
  'pin',
  'chevRight',
  'chevDown',
  'user',
  'lock',
  'logout',
  'plus',
  'android',
  'ios',
  'windows',
  'globe',
  'admissions',
  'bedBoard',
  'nursingStation',
  'doctorStation',
  'wardSetup',
] as const;

